/* ===================================================================
   HotanExpress — Home animations engine (subtle)
   - Auto-applies scroll reveal to home sections
   - Animates counters with [data-cr-count]
   No dependencies. Safe to load on every page.
   =================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Auto-tag elements for reveal --------------------------- */
  // Targets the headings + cards inside HotanExpress sections automatically,
  // so you don't have to edit any section markup.
  var revealTargets = [
    '.hotan-section-heading',
    '.hotan-value-card',
    '.hotan-quote',
    '.hotan-faq__item',
    '.hotan-hero__content',
    '.hotan-hero__visual'
  ];

  document.querySelectorAll(revealTargets.join(',')).forEach(function (el) {
    el.classList.add('cr-reveal');
  });

  // Stagger cards within the same grid for a cascade feel
  function stagger(selector, step) {
    var groups = {};
    document.querySelectorAll(selector).forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      if (!groups[parent.dataset.crGroup]) {
        parent.dataset.crGroup = Math.random().toString(36).slice(2);
      }
    });
    document.querySelectorAll(selector).forEach(function (el) {
      var siblings = Array.prototype.slice.call(el.parentElement.children)
        .filter(function (c) { return c.classList.contains('cr-reveal'); });
      var idx = siblings.indexOf(el);
      if (idx > 0) el.style.setProperty('--cr-reveal-delay', (idx * step) + 'ms');
    });
  }
  stagger('.hotan-value-card', 90);
  stagger('.hotan-quote', 90);
  stagger('.hotan-faq__item', 70);

  /* ---- 2. Reveal on scroll via IntersectionObserver -------------- */
  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.cr-reveal').forEach(function (el) {
      el.classList.add('cr-in');
    });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cr-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.cr-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- 3. Counters ----------------------------------------------- */
  function animateCount(el) {
    var to = parseFloat(el.getAttribute('data-cr-count')) || 0;
    var decimals = parseInt(el.getAttribute('data-cr-decimals'), 10) || 0;
    var prefix = el.getAttribute('data-cr-prefix') || '';
    var suffix = el.getAttribute('data-cr-suffix') || '';
    var dur = parseInt(el.getAttribute('data-cr-duration'), 10) || 1600;

    if (reduce) {
      el.textContent = prefix + to.toFixed(decimals) + suffix;
      return;
    }

    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = eased * to;
      var shown = decimals > 0
        ? val.toFixed(decimals)
        : Math.round(val).toLocaleString();
      el.textContent = prefix + shown + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  var counters = document.querySelectorAll('[data-cr-count]');
  if (counters.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            cio.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }
})();
